import React, { useState, useEffect } from 'react'
import { SidebarData } from './SidebarData'
import { Link, NavLink } from 'react-router-dom'
import { DownloadButton } from '../Button/Button'
import { Wrapper, BankModalBackground } from './style'
import { getOS } from 'src/utils/getOS'

import {
  FKlogo,
  Downloadimg,
  HamburgerOpen,
  HamburgerClose,
} from 'src/assets/index'
import set from 'date-fns/fp/set/index'

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(true)

  const [OSName, setOSName] = useState('Android')
  useEffect(() => {
    const platform = getOS()
    setOSName(platform)
  }, [])

  const getOSName = (e: any) => {
    e.preventDefault()
    if (OSName === 'iOS' || OSName === 'Mac OS') {
      window.open('https://bit.ly/fandksavings-ios')
    }
    window.open('http://bit.ly/2TWL5dz')
  }
  const showSidebar = () => setSidebar(!sidebar)
  const closeSidebar = () => {
    if (sidebar) {
      setSidebar(false)
    }
  }
  return (
    <Wrapper>
      <div className="navbar">
        <Link to="#" className="menu-bars">
          <img
            className="hamimgOpen"
            src={HamburgerOpen}
            alt=""
            onClick={showSidebar}
          />
        </Link>
      </div>
      <div
        className={sidebar ? 'active-class mb' : 'mb'}
        onClick={closeSidebar}
      >
        <nav className={sidebar ? 'nav-menu activer' : 'nav-menu'}>
          <ul className="nav-menu-items">
            <div>
              <div className="hamClose">
                <img src={FKlogo} className="logo" alt="F & K logo" />
              </div>
              <div className="top-bar">
                {SidebarData.map((item, index) => {
                  return (
                    <NavLink to={item.path} key={index} className={item.cName}>
                      {item.icon}
                      <span>{item.title}</span>
                    </NavLink>
                  )
                })}
              </div>
            </div>

            <div className="download">
              <img src={Downloadimg} className="imgDownload" alt="" />
              <p className="downloadp">
                Download our Mobile
                <br /> App and be updated
              </p>
              <DownloadButton onClick={getOSName}>Download App</DownloadButton>
            </div>
          </ul>
        </nav>
      </div>
      <div className={sidebar ? 'active-class lg' : 'lg'}>
        <nav className={sidebar ? 'nav-menu activer' : 'nav-menu activer'}>
          <ul className="nav-menu-items">
            <div>
              <div className="hamClose">
                <img src={FKlogo} className="logo" alt="F & K logo" />
              </div>
              <div className="top-bar">
                {SidebarData.map((item, index) => {
                  return (
                    <NavLink to={item.path} key={index} className={item.cName}>
                      {item.icon}
                      <span>{item.title}</span>
                    </NavLink>
                  )
                })}
              </div>
            </div>

            <div className="download">
              <img src={Downloadimg} className="imgDownload" alt="" />
              <p className="downloadp">
                Download our Mobile
                <br /> App and be updated
              </p>
              <DownloadButton onClick={getOSName}>Download App</DownloadButton>
            </div>
          </ul>
        </nav>
      </div>
    </Wrapper>
  )
}

export { Sidebar }
